
import {reducer as variables } from './variable.reducer';
import {reducer as outputs } from './outputs.reducer';

export const wiloReducers = {
    variables,
    outputs
};
